import React from "react";
import RectangleIcon from "@mui/icons-material/Rectangle";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import ImageIcon from "@mui/icons-material/Image";
import QrCodeIcon from "@mui/icons-material/QrCode";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import BadgeSizeLabel from "./BadgeSizeLabel";

export const Controls = ({
  addRectangle,
  addText,
  handleImageOpen,
  onAddLogo,
  handleQrCodeOpen,
  logTemplate,
  size,
  onChangeSizeClick,
}) => (
  <div className="controls" data-tour="badge-editor-controls">
    <button className="button" onClick={addRectangle}>
      <div className="control-button-content">
        <RectangleIcon className="control-button-icon" />
        <div className="control-button-text">
          <div className="control-button-title">Add rectangle</div>
          <div className="control-button-description">
            Square, rectangle, line
          </div>
        </div>
      </div>
    </button>
    <button className="button" onClick={addText}>
      <div className="control-button-content">
        <TextFieldsIcon className="control-button-icon" />
        <div className="control-button-text">
          <div className="control-button-title">Add static text</div>
          <div className="control-button-description">e.g. Event name</div>
        </div>
      </div>
    </button>
    <button className="button" onClick={handleImageOpen}>
      <div className="control-button-content">
        <ImageIcon className="control-button-icon" />
        <div className="control-button-text">
          <div className="control-button-title">Add image</div>
          <div className="control-button-description">e.g. Event logo</div>
        </div>
      </div>
    </button>
    <button className="button" onClick={handleQrCodeOpen}>
      <div className="control-button-content">
        <QrCodeIcon className="control-button-icon" />
        <div className="control-button-text">
          <div className="control-button-title">Add QR & barcode</div>
          <div className="control-button-description">e.g. Event site url</div>
        </div>
      </div>
    </button>

    {/* Render Add logo button only in development environment */}
    {process.env.NODE_ENV === 'development' && (
      <button className="button" onClick={onAddLogo}>
        <div className="control-button-content">
          <ImageIcon className="control-button-icon" />
          <div className="control-button-text">
            <div className="control-button-title">Add logo</div>
          </div>
        </div>
      </button>
    )}

    {/* Render Get template button only in development environment */}
    {process.env.NODE_ENV === 'development' && (
      <button className="button" onClick={logTemplate}>
        <div className="control-button-content">
          <SaveAltIcon className="control-button-icon" />
          <div className="control-button-text">
            <div className="control-button-title">Get template</div>
          </div>
        </div>
      </button>
    )}

    {/* Display selected badge size information */}
    {size && (
      <div className="selected-badge-size">
        <div className="selected-badge-size-header">
          <h4>Badge size</h4>
          {onChangeSizeClick && (
            <button
              className="button link-button change-badge-size-button"
              type="button"
              onClick={onChangeSizeClick}
            >
              Change
            </button>
          )}
        </div>
        <p>
          <BadgeSizeLabel size={size} />
          {!size.displayMmOnly && ` (${size.displaySizeInMm})`}
        </p>
      </div>
    )}
  </div>
);
